const flavorlists = [
  {
    name: "Instant Classic Kunafas",
    slug: "instant-classic-kunafas",
    image: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472055/flavours1_l1nfjy.png",
    backImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559460/instant_classic_back_hkwjji.png",
    frontImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559461/instant_classic_front_bqqlxp.png",
    rotation: "md:rotate-[-8deg] rotate-0",
  },
  {
    name: "Instant Fusion Kunafas",
    slug: "kataifi-kunafa-dough-variants",
    image: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472055/flavours3_aano51.png",
    backImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559469/instant_fusion_back_ireckp.png",
    frontImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559462/instant_fusion_front_k13qrq.png",
    rotation: "md:rotate-[8deg] rotate-3",
  },
  {
    name: "Kunafa Dough",
    slug: "instant-flavoured-kunafas",
    image: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472062/flavours2_hlihvm.png",
    backImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559466/kunafa_dough_back_rejb5b.png",
    frontImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559464/kunafa_dough_front_mkfdfq.png",
    rotation: "md:rotate-[-12deg] -rotate-3",
  },
  {
    name: "Kunafa Cakes",
    slug: "kunafa-cakes",
    image: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472055/flavours1_l1nfjy.png",
    backImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559470/kunafa_cake_back_njfbxz.png",
    frontImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559470/kunafa_cake_front_g7fizf.png",
    rotation: "md:rotate-[16deg] rotate-3",
  },
  {
    name: "Add Ons & Enhancers",
    slug: "spreads-and-drizzles",
    image: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472059/flavours4_x6f4dx.png",
    backImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559460/add_on_back_bmsakp.png",
    frontImage: "https://res.cloudinary.com/ddahd2kco/image/upload/f_auto,q_auto,dpr_auto,c_limit,w_1200/v1770559461/add_on_front_aqhrzj.png",
    rotation: "md:rotate-[-8deg] rotate-0",
  },
];

const nutrientLists = [
  { label: "Potassium", amount: "245mg" },
  { label: "Calcium", amount: "500mg" },
  { label: "Vitamin A", amount: "176mcg" },
  { label: "Vitamin D", amount: "5mcg" },
  { label: "Iron", amount: "1mg" },
];

const cards = [
  {
    src: "https://res.cloudinary.com/ddahd2kco/video/upload/v1770706606/review0_tohfvw.mp4",
    rotation: "rotate-z-[-10deg]",
    name: "Himanshu Rana",
    img: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472244/p1_mkfpnb.png",
    translation: "translate-y-[-5%]",
  },
  {
    src: "https://res.cloudinary.com/ddahd2kco/video/upload/v1770706587/review1_shsf3a.mp4",
    rotation: "rotate-z-[4deg]",
    name: "Rudraksh Sharma",
    img: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472245/p2_pf5pby.png",
  },
  {
    src: "https://res.cloudinary.com/ddahd2kco/video/upload/v1770706588/review2_tbhin5.mp4",
    rotation: "rotate-z-[-4deg]",
    name: "Aniket",
    img: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472247/p3_aibuyq.png",
    translation: "translate-y-[-5%]",
  },
  {
    src: "https://res.cloudinary.com/ddahd2kco/video/upload/v1770706587/review3_rlzsn5.mp4",
    rotation: "rotate-z-[4deg]",
    name: "Shaurya Sharma",
    img: "https://res.cloudinary.com/ddahd2kco/image/upload/v1770472248/p4_pgnnsv.png",
    translation: "translate-y-[5%]",
  },
];

export { flavorlists, nutrientLists, cards };
